module.exports = __webpack_public_path__ + "img/ba_hu.ccfec792.svg";